import { t } from '@/i18n';
import { SUFFIX_PREFIX_PRESETS } from '@/config/presets';
import { PresetStringsSuggestions } from './PresetStringsSuggestions';

interface PresetTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  testId: string;
  testIdPrefix: string;
}

export function PresetTextField({ label, value, onChange, testId, testIdPrefix }: PresetTextFieldProps) {
  return (
    <div className="mb-3">
      <label className="form-label">{t(label)}</label>
      <input
        type="text"
        className="form-control"
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <PresetStringsSuggestions
        presets={SUFFIX_PREFIX_PRESETS}
        onSelect={onChange}
        testIdPrefix={testIdPrefix}
      />
    </div>
  );
}
